import { HorizontalRule } from '@interhyp/platform-icons';
import React from 'react';
import { GenericToolbarItem } from "./GenericToolbarItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DividerToolbarItem({
  title = 'Horizontale Linie',
  ...props
}) {
  return /*#__PURE__*/_jsx(GenericToolbarItem, {
    icon: HorizontalRule,
    title: title,
    ...props
  });
}